/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preserve_Line_BreaksInputs */



/**
* | output |
* | --- |
* | "Keep line breaks in text" |
*
* @param {Transcript_Export_Preserve_Line_BreaksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preserve_line_breaks = /** @type {((inputs?: Transcript_Export_Preserve_Line_BreaksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preserve_Line_BreaksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conserver les sauts de ligne dans le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilenumbrüche im Text beibehalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mantieni le interruzioni di riga nel testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранять переносы строк в тексте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conservar saltos de línea en el texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保留文本中的换行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストの改行を保持する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Keep line breaks in text")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manter quebras de linha no texto")
	return /** @type {LocalizedString} */ ("Keep line breaks in text")
});